export default __webpack_public_path__ + "static/media/3 a.3c49cc9c.png";